/**
 * Represents a single day or date of a recurrence
 */ export class DayOrDate {
}
